import type { FC } from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useTranslation } from '@/hooks/useTranslation';
import type { MLProcessSummary } from '../type/MLTypes';

interface MLProcessSelectProps {
  processes: MLProcessSummary[];
  machineId: number | null;
  value: number | null;
  onChange: (id: number) => void;
  disabled: boolean;
}

export const MLProcessSelect: FC<MLProcessSelectProps> = ({
  processes,
  machineId,
  value,
  onChange,
  disabled,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex items-center gap-2">
        <span className="inline-flex h-5 w-5 items-center justify-center rounded-full bg-primary text-2xs font-semibold text-primary-foreground">
          3
        </span>
        <span className="text-sm font-medium text-foreground">
          {t('mlRul.context.step2Label')}
        </span>
      </div>
      <Select
        value={value !== null ? String(value) : ''}
        onValueChange={(v) => onChange(Number(v))}
        disabled={disabled || machineId === null}
      >
        <SelectTrigger className="w-full" data-testid="process-select-trigger">
          <SelectValue placeholder={t('mlRul.context.step2Placeholder')} />
        </SelectTrigger>
        <SelectContent>
          {processes.map((p) => (
            <SelectItem key={p.id} value={String(p.id)}>
              {p.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {machineId !== null && processes.length === 0 && (
        <p className="text-xs text-muted-foreground">{t('mlRul.context.step2NoProcesses')}</p>
      )}
    </div>
  );
};
